<template>
  <button
    type="button"
    class="absolute inset-y-0 right-0 px-3 flex items-center text-blueGray-400 hover:text-blueGray-600 focus:outline-none"
    :aria-label="visible ? hideLabel : showLabel"
    @click="$emit('toggle')"
  >
    <svg
      v-if="visible"
      class="w-5 h-5"
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
    >
      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 3l18 18" />
      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10.58 10.58A2 2 0 0012 14a2 2 0 001.42-.58" />
      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9.88 4.24A9.77 9.77 0 0112 4c5 0 8.27 3.11 10 8a13.18 13.18 0 01-2.15 3.57" />
      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6.61 6.61A13.53 13.53 0 002 12c1.73 4.89 5 8 10 8a9.78 9.78 0 004.39-1.01" />
    </svg>
    <svg
      v-else
      class="w-5 h-5"
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
    >
      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7S2 12 2 12z" />
      <circle cx="12" cy="12" r="3" stroke-width="2" />
    </svg>
  </button>
</template>

<script>
export default {
  name: 'PasswordVisibilityToggle',
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    showLabel: {
      type: String,
      default: 'Показать пароль',
    },
    hideLabel: {
      type: String,
      default: 'Скрыть пароль',
    },
  },
  emits: ['toggle'],
};
</script>
